import React from "react";

import "./AudioControl.scss";

export interface IAudioControlProps {
  onClick: () => void;
  svgIcon: React.ReactNode;
  ariaLabel?: string;
}

export const AudioControl: React.FC<
  React.PropsWithChildren<IAudioControlProps>
> = ({ svgIcon, onClick, ariaLabel }) => (
  <button
    className="c-audio-control flex items-center justify-center"
    onClick={onClick}
    aria-label={ariaLabel}
  >
    {svgIcon}
  </button>
);
